import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsPhoneType } from 'common/customers/services/types/RsPhoneType';
import { RsPhoneTypeInfo } from 'common/customers/services/types/RsPhoneTypeInfo';
import { PhoneTypeAdd } from 'common/customers/services/types/PhoneTypeAdd';
import { PhoneTypeUpdate } from 'common/customers/services/types/PhoneTypeUpdate';

export function phoneTypeFromGetToUpdateParams(data: RsPhoneTypeInfo): PhoneTypeUpdate {
    return {
        active: data.active,
        endDate: data.endDate,
        name: data.name,
        notes: data.notes,
        orderNo: data.orderNo,
        startDate: data.startDate
    };
}

export type IPhoneTypeDataProvider = IDataProviderV2<RsPhoneType, RsPhoneTypeInfo, PhoneTypeAdd, PhoneTypeUpdate>;

@A9Service('phoneTypeDataProvider')
export class PhoneTypeDataProvider
    extends AbstractDataProviderV2<RsPhoneType, RsPhoneTypeInfo, PhoneTypeAdd, PhoneTypeUpdate>
    implements IPhoneTypeDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/phone-types');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
